import React from "react";
import "../stylesheets/main.css";
import { Grid } from 'react-bootstrap';
import Navigation from './components/Navigation.js';
import Footer from './components/Footer.js';
import Header from './components/Header.js';

class App extends React.Component {
  	render() {
	    return (
		    <div  id="app-main" className=" padding-0 expand-div">
		    	<Navigation/>
			    <Header/>
		        <Grid id="content" className="flex-anchor">
		        	{ this.props.children }
			    </Grid>
			    <Footer/>
		    </div>
	    );
  	}
}

export default App;


// WEBPACK FOOTER //
// ./src/ui/App.js